import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { formatShortNumber } from "../CommonFun";

export default function DropdownPayment({ name, bannerFilter, filterCallBack, hKey ,filterReset}) {
    const [data, setData] = useState(name);
    const [selectOptions, setSelectOptions] = useState(bannerFilter);

    useEffect(() => {
        setSelectOptions(bannerFilter);
    }, [bannerFilter]);

    const handlePriceChange = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let value = e.target.value;
        let name = e.target.name;
        let option = { ...selectOptions };
        if (name === hKey) {
            if (value !== "") option[name] = value;
            else option[name] = "";
            setSelectOptions(option);
            filterCallBack(option);
        }
    };
    const handleDone = () => {
        let minPce = selectOptions.hKey;
        let value = minPce ? `${formatShortNumber(minPce)}` : name;
        setData(value);
    };
    const handleRemove = () => {
        let option = { ...selectOptions };
        option[hKey] = "";
        setSelectOptions(option);
        filterCallBack(option);
        setData(name);
        filterReset()
    };

    return (
        <div className="filter-dropdown">
            <DropdownButton
                className="custom-dropdown dropdown-button"
                title={` ${
                    selectOptions?.[hKey]
                        ? selectOptions?.[hKey] >= 0 && selectOptions?.[hKey] != 100
                            ? `${selectOptions?.[hKey]}% ${hKey === "paymentPlan" ? data.split(" ")[0] : "Completed"}`
                            : data
                        : data
                }`}
            >
                <div className="">
                    <ul className="dropdown_tlt">
                        <li>{hKey === "paymentPlan" ? "Pre-handover Payment" : "% Completion"}</li>
                    </ul>
                    <div className="range_head">
                        <span>0%</span>
                        <span>100%</span>
                    </div>
                    <input
                        type="range"
                        className="styled-range position-relative"
                        name={hKey}
                        min={0}
                        max={100}
                        value={selectOptions[hKey] ? selectOptions[hKey] : 100}
                        onChange={handlePriceChange}
                        title={selectOptions?.hKey}
                        style={{
                            background: `linear-gradient(to right, var(--primaryColor) 0%, var(--primaryColor) ${selectOptions[hKey] ? selectOptions[hKey] : 100}%, #e0e0e0 ${
                                selectOptions[hKey] ? selectOptions[hKey] : 100
                            }%, #e0e0e0 100%)`,
                            height: "8px",
                            borderRadius: "5px",
                            appearance: "none",
                            WebkitAppearance: "none",
                            outline: "none",
                        }}
                    />
                </div>
                {/* <Dropdown.Item as="span" className="full-width">
                    <button
                        className="reset-button"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleRemove();
                        }}
                    >
                        Reset
                    </button>
                    <button className="done-button" onClick={handleDone}>
                        Done
                    </button>
                </Dropdown.Item> */}
            </DropdownButton>
        </div>
    );
}
